// Detect if JS is enabled
document.documentElement.classList.remove('no-js'); 